export const MENUS = {
    NONE: null,
    MORE: 'MORE',
    OUTPUT: 'OUTPUT',
    MEMBERS: 'MEMBERS',
    ADDPERSON: 'ADDPERSON',
    VIEWS: 'VIEWS',
};